import CounterModel from "../models/CounterModel";

const CounterViewModel = {
  getCounter: async () => {
    return await CounterModel.fetchCounter();
  },

  getPaginatedImageKeys: (counter, pageNumber, itemsPerPage = 12) => {
    const startIndex = (pageNumber - 1) * itemsPerPage;
    const keys = [];
    for (let i = 0; i < itemsPerPage; i++) {
        const key = counter - startIndex - i;
        if (key >= 0) {
            keys.push(key);
        }
    }
    return keys;
  }
};

export default CounterViewModel;
